import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import ShaderBackground from './components/background/BO3Background';
import BO3Menu from './components/startmenu';
import ToolsPage from './components/pages/tools';
import AboutPage from './components/pages/AboutPage';
import UnrealDBPage from './components/pages/UnrealDB';
import SDKView from './components/pages/tools/SDKView';
import GlobalScrollbarStyle from './components/scrollbars';
import PageTransition from './components/pagetransition';
import { themes } from './components/themes';
import AdminPanel from './components/pages/AdminPage';

function App() {
  const currentTheme = themes.bo3;
  useEffect(() => {
    const preventZoom = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-')) {
        e.preventDefault();
      }
    };

    const preventWheelZoom = (e) => {
      if (e.ctrlKey && e.type === 'wheel') {
        e.preventDefault();
      }
    };

    document.addEventListener('keydown', preventZoom);
    document.addEventListener('wheel', preventWheelZoom, { passive: false });

    return () => {
      document.removeEventListener('keydown', preventZoom);
      document.removeEventListener('wheel', preventWheelZoom);
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="h-screen overflow-y-auto">
      <ShaderBackground theme={currentTheme} />
        <GlobalScrollbarStyle theme={currentTheme}/>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={
              <PageTransition theme={currentTheme}>
                <BO3Menu theme={currentTheme} />
              </PageTransition>
            } />
            <Route path="/tools" element={
              <PageTransition theme={currentTheme}>
                <ToolsPage theme={currentTheme} />
              </PageTransition>
            } />
            <Route path="/admin-panel" element={
              <PageTransition theme={currentTheme}>
              <ShaderBackground theme={currentTheme} />
              <AdminPanel theme={currentTheme} />
              </PageTransition>
            } />
            <Route path="/unreal-db" element={
              <PageTransition theme={currentTheme}>
                <UnrealDBPage />
              </PageTransition>
            } />
            <Route path="/about" element={
              <PageTransition theme={currentTheme}>
                <AboutPage  theme={currentTheme} />
              </PageTransition>
            } />
            <Route path="/sdk-view" element={
              <PageTransition theme={currentTheme}>
                <SDKView />
              </PageTransition>
            } />
          </Routes>
        </AnimatePresence>
      </div>
    </BrowserRouter>
  );
}

export default App;
